import Vue from "vue"

import {
  ValidationProvider,
  ValidationObserver,
  extend,
  localize
} from "vee-validate";

// Importa e injeta todas as regras padrão do vee-validate.
import * as rules from "vee-validate/dist/rules";
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

// Importa e injeta as regras custimizadas.
import documento_fiscal from "./vee-validate-rules/documento_fiscal";
extend("documento_fiscal", documento_fiscal)

// Ativa tradução.
import pt_BR from "vee-validate/dist/locale/pt_BR.json";
localize("pt_BR", pt_BR);

// Injeta componentes
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);